var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkGooglePlay = function SvgLinkGooglePlay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "61.231%",
    x2: "26.324%",
    y1: "4.839%",
    y2: "71.968%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".657%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.01%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.04%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "107.728%",
    x2: "-130.665%",
    y1: "49.428%",
    y2: "49.428%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.54%",
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "86.389%",
    x2: "-49.888%",
    y1: "30.83%",
    y2: "136.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "-18.579%",
    x2: "42.275%",
    y1: "-11.682%",
    y2: "35.064%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.85%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.62%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.09%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1.185.423C.93.677.762 1.1.762 1.608v18.7c0 .507.169.93.423 1.184l.084.085 10.493-10.492v-.17L1.185.423z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m15.23 14.638-3.468-3.469v-.254l3.469-3.469.084.085L19.462 9.9c1.184.677 1.184 1.777 0 2.454l-4.231 2.284z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M15.315 14.554 11.762 11 1.185 21.577c.423.423 1.015.423 1.777.085l12.353-7.108",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M15.315 7.446 2.962.423C2.2 0 1.608.085 1.185.508L11.762 11l3.553-3.554z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.23 15.47 3.963 22.407c-.677.423-1.27.338-1.693 0l-.084.084.084.085c.423.338 1.016.423 1.693 0l12.269-7.108z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.185 22.408c-.254-.254-.339-.677-.339-1.185v.085c0 .507.17.93.423 1.184v-.084h-.084z",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m20.462 13.1-4.231 2.37.084.084 4.147-2.37c.592-.338.846-.76.846-1.184 0 .423-.339.762-.846 1.1z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m3.962 1.508 16.5 9.392c.507.338.846.677.846 1.1 0-.423-.254-.846-.846-1.185l-16.5-9.392c-1.185-.677-2.116-.085-2.116 1.27v.084c0-1.354.93-1.946 2.116-1.27z",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkGooglePlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-google-play.c7f79154c602f19aed1ecd494afc88eb.svg";